import { Collapse } from "@mui/material";
import styles from "./SectionTitle.module.scss";
import { ChevronLeftOutlined } from "@mui/icons-material";
import classNames from "classnames";
import { useState } from "react";

const SectionTitle = ({
  icon,
  title,
  collapsible = false,
  defaultOpen = false,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <>
      <h3
        className={classNames(styles["section-title"], {
          [styles["collapse"]]: collapsible,
        })}
        onClick={() => collapsible && setOpen(!open)}
      >
        {icon} <span>{title}</span>
        {collapsible && (
          <span
            className={classNames(styles["collapse-icon"], {
              [styles["open"]]: open,
            })}
          >
            <ChevronLeftOutlined />
          </span>
        )}
      </h3>
      {collapsible && <Collapse in={open}>{children}</Collapse>}
    </>
  );
};

export default SectionTitle;
